import {CommonModule} from '@angular/common';
import {
	Component,
	Injector,
	Input,
	OnDestroy,
	OnInit,
	Type,
	ViewChild,
	ViewContainerRef,
} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {
	AppDrawerDynamicDialogRef,
	buildDrawerDynamicDialogConfig,
} from './app-drawer-dynamic-adapters';
import {DrawerEntry} from './app-drawer.types';

@Component({
	selector: 'ngx-app-component-drawer',
	standalone: true,
	imports: [CommonModule, ButtonModule],
	styles: [`
		:host {
			display: flex;
			flex-direction: column;
			flex: 1 1 auto;
			min-height: 0;
			width: 100%;
			height: 100%;
			justify-content: flex-start;
			align-items: stretch;
			align-self: stretch;
		}
	`],
	template: `
		<div class="app-drawer-frame" [class.app-drawer-frame--sticky-chrome]="entry.stickyChrome">
			<header *ngIf="entry.showHeader && entry.header" class="app-dynamic-drawer__header">
				<h2 class="app-dynamic-drawer__title">{{ entry.header }}</h2>
			</header>
			<p-button
				*ngIf="entry.showCloseButton"
				type="button"
				class="app-drawer-close"
				icon="pi pi-times"
				size="small"
				[rounded]="true"
				[text]="true"
				severity="secondary"
				[attr.aria-label]="'Fermer'"
				(onClick)="close()"
			></p-button>
			<div class="app-drawer-scroll" #host></div>
		</div>
	`,
})
export class AppComponentDrawerComponent implements OnInit, OnDestroy {
	@Input({required: true}) entry!: DrawerEntry;
	@ViewChild('host', {read: ViewContainerRef, static: true}) host!: ViewContainerRef;

	constructor(private readonly injector: Injector) {
	}

	ngOnInit(): void {
		const dynamicRef = new AppDrawerDynamicDialogRef(this.entry.ref);
		const dialogConfig = buildDrawerDynamicDialogConfig(this.entry);
		const childInjector = Injector.create({
			providers: [
				{provide: DynamicDialogRef, useValue: dynamicRef},
				{provide: DynamicDialogConfig, useValue: dialogConfig},
			],
			parent: this.injector,
		});
		const componentRef = this.host.createComponent(this.entry.content as Type<unknown>, {
			injector: childInjector,
		});
		this.entry.ref.componentRef = componentRef.instance;
	}

	ngOnDestroy(): void {
		this.host.clear();
	}

	close(): void {
		this.entry.ref.close();
	}
}
